// extracted by mini-css-extract-plugin
export default {"containerOption":"Eaa-z","step":"Faa-z","boxes":"Gaa-z"};